<template>
  <div style="background-color: #f6f6f6; min-height: 100vh">
    <div style="background-color: #fff">
      <!-- banner -->
      <van-swipe class="homebanner" :autoplay="3000" indicator-color="white">
        <van-swipe-item
          v-for="banner in details.imgs ? details.imgs.split(',') : []"
          :key="banner"
        >
          <img v-if="banner" :src="banner" style="height: 250px" />
          <img
            v-else
            src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/16b3.png"
            style="height: 250px"
          />
        </van-swipe-item>
      </van-swipe>
      <div class="bg">
        <div class="title">
          <!-- 出租方式 -->
          {{ details.deptName }} |
          {{ details.name }}
        </div>
        <div class="money">
          {{ details.price
          }}<i style="font-style: normal; font-size: 13px; margin-right: 10px"
            >元/小时</i
          >
          <i style="font-style: normal; font-size: 13px; color: #666666">{{
            details.Deposit
          }}</i>
        </div>
      </div>
    </div>
    <div class="mid">
      <div>预约必读</div>
      <div v-if="details.responsiblePerson">
        <i
          style="
            font-style: normal;
            font-size: 13px;
            font-weight: 400;
            color: #666666;
          "
          >联系人</i
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ details.responsiblePerson }}
      </div>
      <div v-if="details.responsiblePhone">
        <i
          style="
            font-style: normal;
            font-size: 13px;
            font-weight: 400;
            color: #666666;
          "
          >联系电话</i
        >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ details.responsiblePhone }}
      </div>
      <div>
        <i
          style="
            font-style: normal;
            font-size: 13px;
            font-weight: 400;
            color: #666666;
          "
          >类型</i
        >&nbsp;&nbsp;&nbsp;{{ details.typeName }}
      </div>
    </div>

    <div class="phoneAndInbox">
      <div
        style="float: right; text-align: center; width: 15%"
        @click="callPhone(details.responsiblePhone)"
      >
        <img
          src="https://new-zhsq.oss-cn-beijing.aliyuncs.com/goodsImg/fe0b.png"
          style="width: 30%"
        />
        <div style="font-size: 13px; font-weight: 400">电话</div>
      </div>
    </div>
    <div class="mid" style="height: 95px; padding: 0 5%">
      <img
        src="https://dximg.dexian.ren/map.png"
        alt=""
        style="width: 100%; height: 95px; position: absolute"
      />
      <div class="add">
        <img
          src="https://dximg.dexian.ren/address.png"
          style="width: 12px; vertical-align: middle; margin-right: 2%"
        />{{ details.address }}
        <!-- {{details.Coordinate}} -->
      </div>
      <div @click="gotominiProgram(details)" class="yuyue">地图/周边</div>
      <img
        class="yuyue"
        style="width: 5px; right: 6%"
        src="https://dximg.dexian.ren/right.png"
        alt=""
      />
    </div>

    <div class="mid mid2" style="margin-bottom: 1px">
      <div>详情</div>
      <div style="font-weight: 400" v-html="details.content"></div>
    </div>
    <div class="btnBox">
      <van-button type="info" class="btnBox_btn" block @click="onShowFun(1)"
        >预约</van-button
      >
       <!-- <van-button type="info" class="btnBox_btn" block @click="goAppointment()"
        >预约</van-button
      > -->
       <!-- <van-button type="info" class="btnBox_btn" block @click="postFun()"
        >预约</van-button
      > -->
      
    </div>
    <van-popup
      v-model="popupShow"
      position="bottom"
      custom-style="height: 30%"
      @cancel="onClose(1)"
    >
      <div class="popupBox">
        <van-field
          type="text"
          v-model="inputDate"
          @click="onShowFun(2)"
          placeholder="请选择时间"
          readonly
          class="popupBox_input"
        />
        <div class="popupBox_box">
          <div
            :class="[
              item.available_capacity == 0
                ? 'popupBox_box_div1 popupBox_box_div'
                : 'popupBox_box_div2 popupBox_box_div',
              item.checked ? 'popupBox_box_div3' : '',
            ]"
            v-for="(item, index) in hoursList"
            :key="index"
            @click="timeChange(item)"
          >
            <span class="popupBox_box_div_span1">{{ item.hour_slot }}</span>
            <span class="popupBox_box_div_span2">{{ item.status }}</span>
          </div>
        </div>
        <div class="btnBox">
          <van-button type="info" class="btnBox_btn" block @click="submitFun()"
            >预约提交</van-button
          >
        </div>
      </div>
      <div>
        <van-popup
          v-model="popupShowtime"
          position="bottom"
          custom-style="height: 20%"
          @cancel="onClose(2)"
        >
          <van-datetime-picker
            v-model="ShowTime"
            type="date"
            title="选择预约时间"
            :min-date="minDate"
            @cancel="popupShowtime = false"
            @confirm="onfuwushow"
          />
        </van-popup>
      </div>
    </van-popup>
  </div>
</template>

<script>
import {
  getInfo,
  getCountByHour,
  appointmentRecord,
} from "@/api/Changan-zhsq/sharedSpace";
import "swiper";
import Vue from "vue";
import { Toast } from "vant";
import { Dialog } from "vant";

Vue.use(Toast);
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  data() {
    return {
      booleanData: false,
      minDate: new Date(),
      maxDate: new Date(2038, 12, 30),
      datafrom: {
        LeaseId: "", // 房源ID
        ShowTime: new Date(), // 看房时间
      },
      details: {},
      list: [],
      popupShow: false,
      ShowTime: new Date(),
      inputDate: "",
      popupShowtime: false,
      hoursList: [],
      selectTime: [],
      endTimeList: [],
      recordId: ''
    };
  },
  created() {
    console.log(this.$route.params);
    this.inputDate = this.formatDateTime(new Date());
    this.wxGetPromotion(); //商品详情
  },
  methods: {
    // 格式化函数（直接复制到JS中使用）
    formatDateTime(timestamp) {
      if (!timestamp) return "";
      // 创建Date对象（时间戳为毫秒）
      const date = new Date(timestamp);
      // 获取年、月、日、时、分、秒
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0"); // 月份从0开始
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");
      const seconds = String(date.getSeconds()).padStart(2, "0");

      // 返回格式化后的字符串
      // return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      return `${year}-${month}-${day}`;
    },
    gotominiProgram(details) {
      console.log(details);
      if (details.coordinates == "" || details.coordinates == null) {
        Toast.fail("暂无位置信息");
      } else {
        this.nameCc = {
          Navigation: "导航",
          Coordinate: details.coordinates,
        };
        if (window.__wxjs_environment === "miniprogram") {
          window.wx.miniProgram.navigateTo({
            url:
              "/pages/openminip/openminip?name=" + JSON.stringify(this.nameCc),
          });
        } else {
          alert("请在小程序中打开");
        }
      }
    },
    onfuwushow() {
      this.popupShowtime = false;
      this.inputDate = this.formatDateTime(this.ShowTime);
      this.getCounHourFun();
    },
    onShowFun(type) {
      console.log(type);
      if (type == 1) {
        this.popupShow = true;
        this.getCounHourFun();
        this.selectTime = [];
      } else if (type == 2) {
        this.popupShowtime = true;
      }
    },
    goAppointment() {
      if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url:
            "/pages/sharedSpace/appointment/appointment?id=" + this.details.id,
        });
      } else {
        alert("请在小程序中打开");
      }
    },
    callPhone(phone) {
      window.location.href = "tel:" + phone;
    },
    // 获取房源详情
    wxGetPromotion() {
      const id = this.$route.params.id;
      getInfo(id).then((response) => {
        this.details = response.data.data;
        // this.form.gName = response.data.deptName;
      });
    },
    getCounHourFun() {
      getCountByHour({ date: this.inputDate }).then((response) => {
        response.data.data.forEach((e) => {
          e.checked = false;
        });
        console.log(this.addEndHour(response.data.data));
        this.hoursList = this.addEndHour(response.data.data);
        // this.form.gName = response.data.deptName;
      });
    },
    /**
     * 为时间槽数组添加 end_hour 字段（格式：HH:59）
     * @param {Array} slots - 包含 hour_slot 的时间槽数组
     * @returns {Array} 新数组，每个对象包含 end_hour 字段
     */
    addEndHour(slots) {
      return slots.map((slot) => {
        // 确保 hour_slot 存在且格式正确（如 "09:00"）
        if (!slot.hour_slot || typeof slot.hour_slot !== "string") {
          console.warn("Invalid hour_slot:", slot);
          return { ...slot };
        }
        // 提取小时部分（前两位）
        const hour = slot.hour_slot.substring(0, 2);
        // 验证是否为有效小时（00-23）
        if (!/^[0-2][0-9]$/.test(hour)) {
          console.warn("Invalid hour format:", slot.hour_slot);
          return { ...slot };
        }
        const endHour = `${hour}:59`;
        // 返回新对象，保留原属性并添加 end_hour
        return {
          ...slot,
          end_hour: endHour,
        };
      });
    },
    onClose(type) {
      if (type == 1) {
        this.popupShow = false;
      } else if (type == 2) {
        this.popupShowtime = false;
      }
    },
    selectRangeInObjectsStrict(
      arr,
      startKey,
      endKey,
      key = "hour_slot",
      statusKey = "status"
    ) {
      const startIndex = arr.findIndex((item) => item[key] === startKey);
      const endIndex = arr.findIndex((item) => item[key] === endKey);

      if (startIndex === -1) throw new Error(`未找到起始项: ${startKey}`);
      if (endIndex === -1) throw new Error(`未找到结束项: ${endKey}`);
      const [startIdx, endIdx] =
        startIndex <= endIndex
          ? [startIndex, endIndex]
          : [endIndex, startIndex];
      const range = arr.slice(startIdx, endIdx + 1);
      // 校验中间是否全部为空闲
      const allAvailable = range.every((item) => item[statusKey] === "可预约");
      if (!allAvailable) {
        Toast({
          type: "fail",
          message: "中间存在非空闲时段，无法选择连续区间,请重新选择！",
          duration: 3000,
          onClose: () => {
            arr.forEach((e) => {
              e.checked = false;
            });
            this.selectTime = [];
          },
        });
        return [];
      }

      return range;
    },
    updateArray(arr, newItem) {
      // 创建数组副本
      const newArr = [...arr];
      newItem.checked = true;

      // 查找 newItem 是否已在数组中（假设用 id 作为唯一标识）
      const index = newArr.findIndex(
        (item) => item.hour_slot === newItem.hour_slot
      );

      // 情况1：元素已存在 → 移除它，并设置 checked = false
      if (index > -1) {
        const removedItem = newArr[index];
        if (removedItem && typeof removedItem === "object") {
          removedItem.checked = false; // 标记为未选中
        }
        newArr.splice(index, 1); // 从数组中删除
        return newArr;
      }

      // 情况2：元素不存在
      if (newArr.length >= 2) {
        // 数组已满，替换最后一个（第二个）
        const replacedItem = newArr[1];
        if (replacedItem && typeof replacedItem === "object") {
          replacedItem.checked = false; // 被替换的元素 checked = false
        }
        // 新元素 checked = true
        newArr[1] = newItem;
      } else {
        // 数组未满，直接添加
        newArr.push(newItem);
      }
      return newArr;
    },
    timeChange(item) {
      const list = this.updateArray(this.selectTime, item);
      this.selectTime = list;
      console.log(list, this.selectTime);
      if (this.selectTime.length == 2) {
        this.endTimeList = this.selectRangeInObjectsStrict(
          this.hoursList,
          this.selectTime[0].hour_slot,
          this.selectTime[1].hour_slot
        );
      } else {
        this.endTimeList = this.selectTime;
      }
      console.log(this.endTimeList);
    },
    submitFun() {
      if (this.selectTime.length == 0) {
        Toast("请选择预约时间");
        return;
      }
      let beginTime = ''
      let endTime = ''
      if(this.selectTime.length == 2){
        beginTime = this.selectTime[0].hour_slot
        endTime = this.selectTime[1].end_hour
      }else{
        beginTime = this.selectTime[0].hour_slot
        endTime = this.selectTime[0].end_hour
      }
      const data = {
          beginTime:this.inputDate+' ' + beginTime + ':00',
      endTime:this.inputDate +' '+ endTime + ':00',
      infoId: this.$route.params.id,
      openId: this.$route.params.openId,
      typeId: this.details.appointmentType

      }
        appointmentRecord(data).then((response) => {
               Toast.success("预约成功");
                this.popupShowtime = false;
                 this.popupShow = false;
                 this.recordId = response.data.msg
                 this.goPayPage()
            });
    },
    goPayPage(){

 if (window.__wxjs_environment === "miniprogram") {
        window.wx.miniProgram.navigateTo({
          url:
            "/pages/sharedSpace/pay/pay?id=" + this.details.id+ '&recordId=' + this.recordId + "&hour=" + this.endTimeList.length,
        });
      } else {
        alert("请在小程序中打开");
      }
    },
  },
};
</script>

<style scoped>
body {
  background-color: #f6f6f6;
}

.bg {
  width: 90%;
  margin: 15px auto;
}

.homebanner {
  width: 100%;
  /* margin-top: 15px; */
}

.homebanner img {
  width: 100%;
}

.title {
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 800;
  color: #0c0c0c;
}

.money {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #fc4839;
  margin-top: 10px;
}

.des {
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-top: 5%;
  height: 74px;
  border-top: 1px solid #f4f4f4;
  text-align: center;
}

.max {
  font-size: 15px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #0c0c0c;
}

.min {
  font-size: 11px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #999999;
}

.mid {
  position: relative;
  box-sizing: border-box;
  /* height: 97px; */
  padding: 2% 5% 0% 5%;
  background-color: #fff;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #0c0c0c;
  line-height: 22px;
}
.mid2 {
  padding-bottom: 20px;
}

.mid div:nth-child(1) {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #0c0c0c;
  margin: 7px 0;
}

.mid div:nth-child(2),
.mid div:nth-child(3) {
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #0c0c0c;
  line-height: 22px;
}

.mid .yuyue {
  font-size: 13px !important;
  font-family: PingFang SC;
  font-weight: 500 !important;
  color: #4b6c8d !important;
  position: absolute;
  top: 50%;
  right: 10%;
  transform: translateY(-50%);
}

.add {
  width: 88%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.submit {
  width: 90%;
  height: 43.5px;
  background: #fc4839;
  border-radius: 8px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #ffffff;
}

.bottom {
  text-align: center;
  height: 70px;
  line-height: 60px;
  background: #ffffff;
  box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.08);
}

.phoneAndInbox {
  padding: 0% 5% 2% 5%;
  font-style: normal;
  font-size: 13px;
  font-weight: 400;
  color: #666666;
  text-align: end;
  height: 50px;
  background-color: #fff;
  margin-bottom: 12px;
}
.btnBox {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-bottom: 200px;
}
.btnBox_btn {
  width: 90%;
}
.popupBox {
  height: 400px;
  overflow-y: scroll;
}
.popupBox_input {
  width: 90%;
  margin: 20px auto;
  text-align: center;
  border: 1px solid #e1e1e1;
}
.popupBox_box {
  display: flex;
  flex-wrap: wrap;
  padding: 10px;
}
.popupBox_box_div {
  width: calc(33% - 5px);
  height: 50px;
  text-align: center;
  margin-right: 4px;
  margin-bottom: 4px;
  box-shadow: 0px 1px 8px 0 #d1d1d1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.popupBox_box_div1 {
  background-color: #ff7474;
}
.popupBox_box_div2 {
  background-color: #74ffa9;
}
.popupBox_box_div3 {
  border: 1px solid #0084ff;
}
.popupBox_box_div_span1 {
}
.popupBox_box_div_span2 {
  font-size: 12px;
  display: inline-block;
  margin-top: 5px;
  color: #666666;
}
</style>
<style>
.popupBox_input input {
  text-align: center !important;
}
</style>